import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { Title, faUsersGear, PageContainer } from '@/ui/components';
import { useTranslate } from '@/translations';
import { Card } from 'antd';
import { CustomersDataGrid } from './components/CustomersDataGrid/CustomersDataGrid';

export const CustomerManagement: FC = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();

  return (
    <PageContainer>
      <Title
        title={t('customerManagement')}
        icon={faUsersGear}
        color={accent}
      />
      <Card>
        <CustomersDataGrid />
      </Card>
    </PageContainer>
  );
};
